document.documentElement.classList.add('js');

function containDialogFocus(event,dialog){
  if(event.key!=='Tab')return;
  const controls=[...dialog.querySelectorAll('a[href],button,input,select,textarea,summary,[tabindex="0"]')].filter(el=>!el.disabled&&el.getClientRects().length&&getComputedStyle(el).visibility!=='hidden');
  const first=controls[0],last=controls.at(-1);if(!first){event.preventDefault();return;}
  if(event.shiftKey&&(document.activeElement===first||!dialog.contains(document.activeElement))){event.preventDefault();last.focus();}
  if(!event.shiftKey&&(document.activeElement===last||!dialog.contains(document.activeElement))){event.preventDefault();first.focus();}
}

class MultiBrandNavigation extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.dialog = this.querySelector('[data-mobile-menu]');
    this.dialog?.addEventListener('keydown',event=>containDialogFocus(event,this.dialog));
    this.trigger = this.querySelector('[data-open-menu]');
    this.trigger?.addEventListener('click', () => {
      this.dialog.showModal();
      document.body.classList.add('menu-open');
      this.trigger.setAttribute('aria-expanded', 'true');
    });
    this.querySelector('[data-close-menu]')?.addEventListener('click', () => this.dialog.close());
    this.dialog?.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
    this.dialog?.addEventListener('close', () => {
      document.body.classList.remove('menu-open');
      this.trigger?.setAttribute('aria-expanded', 'false');
      this.trigger?.focus();
    });
    this.addEventListener('keydown', event => {
      if (event.key === 'Escape') this.querySelectorAll('details[open]').forEach(detail => { detail.open = false; });
    });
    this.querySelectorAll('.mega-menu').forEach(detail => {
      const summary = detail.querySelector('summary');
      const open = () => {
        clearTimeout(detail.closeTimer);
        detail.classList.remove('is-closing');
        detail.open = true;
      };
      const close = () => {
        clearTimeout(detail.closeTimer);
        detail.classList.add('is-closing');
        detail.closeTimer = setTimeout(() => { detail.open = false; detail.classList.remove('is-closing'); }, 180);
      };
      detail.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && matchMedia('(hover: hover)').matches) open(); });
      detail.addEventListener('pointerleave', () => { if (!detail.contains(document.activeElement)) close(); });
      summary.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') { event.preventDefault(); open(); detail.querySelector('.mega-menu__panel a')?.focus(); }
      });
      detail.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); detail.open = false; summary.focus(); }
      });
      detail.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(detail.open));
        if (detail.open) this.querySelectorAll('.mega-menu').forEach(other => { if (other !== detail) other.open = false; });
      });
      detail.addEventListener('focusout', () => setTimeout(() => {
        if (!detail.contains(document.activeElement)) detail.open = false;
      }, 0));
    });
    this.outside = event => {
      if (!this.contains(event.target)) this.querySelectorAll('details[open]').forEach(detail => { detail.open = false; });
    };
    document.addEventListener('click', this.outside);
    this.resizeObserver = new ResizeObserver(() => document.documentElement.style.setProperty('--header-height', `${this.getBoundingClientRect().height}px`));
    this.resizeObserver.observe(this);
    this.search = this.querySelector('.header-search');
    this.search?.addEventListener('toggle', () => { if (this.search.open) this.search.querySelector('input')?.focus(); });
    this.search?.addEventListener('keydown', event => { if (event.key === 'Escape') { this.search.open = false; this.search.querySelector('summary').focus(); } });
  }
  disconnectedCallback() { document.removeEventListener('click', this.outside); this.resizeObserver?.disconnect(); }
}

class MultiBrandSlideshow extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.tabs = [...this.querySelectorAll('[data-slide-index]')];
    this.current = 0;
    this.paused = false;
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.classList.add('is-enhanced');
    this.slides.forEach((slide,index) => { slide.hidden = false; slide.inert = index !== 0; slide.classList.toggle('is-active',index===0); slide.setAttribute('aria-hidden',String(index!==0)); });
    let touchX, touchY;
    this.addEventListener('touchstart', event => { touchX=event.touches[0].clientX;touchY=event.touches[0].clientY;clearInterval(this.timer); },{passive:true});
    this.addEventListener('touchend', event => {
      const dx=event.changedTouches[0].clientX-touchX,dy=event.changedTouches[0].clientY-touchY;
      if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.4)this.show(this.current+(dx<0?1:-1));
      else this.start();
    },{passive:true});
    this.motionChange=()=>this.start();this.motion.addEventListener('change',this.motionChange);
    this.querySelector('[data-slide-next]')?.addEventListener('click', () => this.show(this.current + 1));
    this.querySelector('[data-slide-previous]')?.addEventListener('click', () => this.show(this.current - 1));
    this.tabs.forEach(tab => tab.addEventListener('click', () => this.show(Number(tab.dataset.slideIndex))));
    this.querySelector('[data-slide-pause]')?.addEventListener('click', event => {
      this.paused = !this.paused;
      event.currentTarget.setAttribute('aria-pressed', String(this.paused));
      event.currentTarget.textContent = this.paused ? event.currentTarget.dataset.playLabel : event.currentTarget.dataset.pauseLabel;
      this.start();
    });
    this.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight') this.show(this.current + 1);
      if (event.key === 'ArrowLeft') this.show(this.current - 1);
    });
    this.addEventListener('mouseenter', () => clearInterval(this.timer));
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => clearInterval(this.timer));
    this.addEventListener('focusout', () => { if (!this.contains(document.activeElement)) this.start(); });
    this.visibility = () => document.hidden ? clearInterval(this.timer) : this.start();
    this.editorSelection = event => {
      const index = this.slides.indexOf(event.target.closest('[data-slide]'));
      if (index >= 0) { this.paused = true; this.show(index); }
    };
    document.addEventListener('visibilitychange', this.visibility);
    this.addEventListener('shopify:block:select', this.editorSelection);
    this.start();
  }
  show(index) {
    if (!this.slides.length) return;
    this.current = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, position) => { const active=position===this.current;slide.classList.toggle('is-active',active);slide.inert=!active;slide.setAttribute('aria-hidden',String(!active)); });
    this.tabs.forEach((tab, position) => tab.setAttribute('aria-pressed', String(position === this.current)));
    const counter = this.querySelector('[data-slide-current]');
    if (counter) counter.textContent = String(this.current + 1).padStart(2, '0');
    this.start();
  }
  start() {
    clearInterval(this.timer);
    if (this.dataset.autoplay !== 'true' || this.paused || document.hidden || this.matches(':hover') || this.contains(document.activeElement) || this.motion.matches) return;
    this.timer = setInterval(() => this.show(this.current + 1), Number(this.dataset.interval) || 7000);
  }
  disconnectedCallback() { clearInterval(this.timer); document.removeEventListener('visibilitychange', this.visibility); this.motion?.removeEventListener('change',this.motionChange); }
}

class MultiBrandProduct extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    const source = this.querySelector('[data-product-variants]');
    if (!source) return;
    try { this.variants = JSON.parse(source.textContent); } catch { return; }
    this.ready = true;
    this.native = this.querySelector('select[name="id"]');
    this.options = [...this.querySelectorAll('[data-option-index]')];
    this.button = this.querySelector('[data-add-to-cart]');
    this.price = this.querySelector('[data-product-price]');
    this.compare = this.querySelector('[data-product-compare]');
    this.availability = this.querySelector('[data-product-availability]');
    this.sku = this.querySelector('[data-product-sku]');
    const initial = this.variants.find(variant => String(variant.id) === this.native?.value) || this.variants[0];
    if (initial) this.options.forEach((option, index) => { option.value = initial.options[index]; });
    this.querySelector('[data-product-options]')?.removeAttribute('hidden');
    if (this.options.length) this.querySelector('.variant-native')?.classList.add('visually-hidden');
    this.options.forEach(option => option.addEventListener('change', () => {
      const values = this.options.map(select => select.value);
      let variant=this.variants.find(item => item.options.every((value, index) => value === values[index]));
      if(!variant?.available){
        const changed=this.options.indexOf(option);
        const compatible=this.variants.find(item=>item.available&&item.options.every((value,index)=>index>changed||value===values[index]));
        if(compatible){variant=compatible;this.options.forEach((select,index)=>select.value=compatible.options[index]);}
      }
      this.select(variant);
    }));
    this.native?.addEventListener('change', () => this.select(this.variants.find(v => String(v.id) === this.native.value)));
    this.querySelectorAll('[data-media-select]').forEach(button => button.addEventListener('click', () => this.media(button.dataset.mediaSelect)));
    if (initial) this.select(initial, false);
    this.form=this.querySelector('form');
    this.form?.addEventListener('submit', async event => {
      const variant = this.variants.find(item => String(item.id) === this.native.value);
      if (!variant?.available || this.native.disabled || this.busy) { event.preventDefault(); this.availability.textContent = this.button.dataset.unavailableLabel;return; }
      const drawer=document.querySelector('mb-cart-drawer');if(!drawer)return;
      event.preventDefault();this.busy=true;this.button.disabled=true;this.button.setAttribute('aria-busy','true');
      this.querySelector('[data-sticky-add]').disabled=true;this.availability.textContent=this.dataset.addingLabel;
      try {
        const payload=new FormData(this.form);payload.set('sections',drawer.dataset.sectionId);payload.set('sections_url',location.pathname);
        const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',headers:{Accept:'application/json'},body:payload});
        const data=await response.json();if(!response.ok)throw new Error(data.description||this.dataset.errorLabel);
        this.availability.textContent=this.dataset.addedLabel;
        const rendered=await drawer.render(data.sections);await rendered.open(this.button,false);
      }catch(error){this.availability.textContent=error instanceof TypeError?this.dataset.errorLabel:error.message||this.dataset.errorLabel;}
      finally{this.busy=false;this.button.removeAttribute('aria-busy');const current=this.variants.find(v=>String(v.id)===this.native.value);this.button.disabled=!current?.available;this.querySelector('[data-sticky-add]').disabled=!current?.available;}
    });
    this.querySelector('[data-sticky-add]')?.addEventListener('click',()=>{if(!this.busy)this.form.requestSubmit();});
    const purchaseActions=this.querySelector('.purchase-actions');
    this.updateSticky=()=>{const box=this.button.getBoundingClientRect(),header=document.querySelector('.section-header')?.getBoundingClientRect().bottom||0;this.querySelector('[data-sticky-purchase]').hidden=box.top>=header;};
    this.purchaseObserver=new IntersectionObserver(this.updateSticky,{threshold:0});this.purchaseObserver.observe(purchaseActions);
    this.stickyScroll=()=>{if(this.stickyFrame)return;this.stickyFrame=requestAnimationFrame(()=>{this.stickyFrame=null;this.updateSticky();});};window.addEventListener('scroll',this.stickyScroll,{passive:true});
    const nextMedia=delta=>{const panels=[...this.querySelectorAll('[data-media-panel]')];const current=panels.findIndex(p=>!p.hidden);if(panels.length)this.media(panels[(current+delta+panels.length)%panels.length].dataset.mediaId);};
    this.querySelector('[data-gallery-previous]')?.addEventListener('click',()=>nextMedia(-1));this.querySelector('[data-gallery-next]')?.addEventListener('click',()=>nextMedia(1));
    const stage=this.querySelector('.product-gallery__stage');let x,y;
    stage?.addEventListener('touchstart',e=>{x=e.touches[0].clientX;y=e.touches[0].clientY;},{passive:true});
    stage?.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-x,dy=e.changedTouches[0].clientY-y;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.4)nextMedia(dx<0?1:-1);},{passive:true});
    stage?.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();nextMedia(e.key==='ArrowRight'?1:-1);}});
    this.variantPop=()=>{const v=this.variants.find(v=>String(v.id)===new URL(location.href).searchParams.get('variant'));if(v){this.options.forEach((el,i)=>el.value=v.options[i]);this.select(v,false);}};window.addEventListener('popstate',this.variantPop);
  }
  format(value) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(value / 100);
  }
  select(variant, updateUrl = true) {
    this.native.disabled = !variant;
    this.button.disabled = !variant?.available;
    const label = !variant ? this.button.dataset.unavailableLabel : variant.available ? this.button.dataset.availableLabel : this.button.dataset.soldOutLabel;
    this.button.childNodes[0].textContent = label + ' ';
    this.availability.textContent = variant?.available ? '' : label;
    const sticky=this.querySelector('[data-sticky-add]');if(sticky){sticky.disabled=!variant?.available;sticky.textContent=label;}
    this.options.forEach((select,index)=>{
      [...select.options].forEach(option=>{option.disabled=!this.variants.some(v=>v.available&&v.options[index]===option.value&&v.options.every((value,i)=>i>=index||value===this.options[i].value));});
      select.dataset.selected=select.value;
    });
    if (!variant) return;
    const stickyPrice=this.querySelector('[data-sticky-price]'),stickyOptions=this.querySelector('[data-sticky-options]');if(stickyPrice)stickyPrice.textContent=this.format(variant.price);if(stickyOptions)stickyOptions.textContent=variant.options.join(' / ');
    this.native.value = String(variant.id);
    this.price.textContent = this.format(variant.price);
    this.compare.hidden = !(variant.compare_at_price > variant.price);
    this.compare.textContent = variant.compare_at_price ? this.format(variant.compare_at_price) : '';
    this.sku.hidden = !variant.sku;
    if (this.sku.querySelector('span')) this.sku.querySelector('span').textContent = variant.sku || '';
    if (variant.media_id) this.media(String(variant.media_id));
    if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
  }
  media(id) {
    this.querySelectorAll('[data-media-panel]').forEach(panel => {
      panel.hidden = panel.dataset.mediaId !== id;
      if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
    });
    this.querySelectorAll('[data-media-select]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaSelect === id)));
    const panels=[...this.querySelectorAll('[data-media-panel]')],index=panels.findIndex(p=>p.dataset.mediaId===id),counter=this.querySelector('[data-gallery-count]');if(counter)counter.textContent=`${index+1} / ${panels.length}`;
  }
  disconnectedCallback(){this.purchaseObserver?.disconnect();window.removeEventListener('popstate',this.variantPop);window.removeEventListener('scroll',this.stickyScroll);cancelAnimationFrame(this.stickyFrame);}
}

class MultiBrandCartDrawer extends HTMLElement {
  connectedCallback(){
    if(this.ready)return;this.ready=true;this.dialog=this.querySelector('dialog');
    this.dialog.addEventListener('keydown',event=>containDialogFocus(event,this.dialog));
    this.addEventListener('click',event=>{
      if(event.target.closest('[data-close-cart]')||event.target===this.dialog){this.dialog.close();return;}
      const button=event.target.closest('[data-quantity-delta],[data-remove-line]');if(!button)return;
      const line=button.closest('[data-line-key]'),quantity=Number(line.querySelector('[data-line-quantity]').value);
      this.change(line.dataset.lineKey,button.hasAttribute('data-remove-line')?0:Math.max(0,quantity+Number(button.dataset.quantityDelta)),button);
    });
    this.addEventListener('change',event=>{if(event.target.matches('[data-line-quantity]')){const input=event.target;this.change(input.closest('[data-line-key]').dataset.lineKey,Math.max(0,Math.floor(Number(input.value)||0)),input);}});
    this.dialog.addEventListener('close',()=>{if(this.replacing)return;document.body.classList.remove('cart-open');this.returnFocus?.focus();});
    this.headerClick=event=>{const link=event.target.closest('a.cart-link');if(!link||event.metaKey||event.ctrlKey)return;event.preventDefault();this.open(link);};document.addEventListener('click',this.headerClick);
  }
  async open(trigger,refresh=false){
    this.returnFocus=trigger||this.returnFocus;this.dialog.showModal();document.body.classList.add('cart-open');this.querySelector('[data-close-cart]').focus();
    // Initial markup and every mutation are server rendered. Opening does not
    // repeat a request or restart the drawer animation.
    if(!refresh)return;
    this.status(this.dataset.loadingLabel);try{await this.render();}catch{this.status(this.dataset.errorLabel);}
  }
  status(text){this.querySelector('[data-drawer-status]').textContent=text;}
  async render(sections){
    let html=sections?.[this.dataset.sectionId];
    if(!html){const url=new URL(location.href);url.searchParams.set('sections',this.dataset.sectionId);const response=await fetch(url,{headers:{Accept:'application/json'}});if(!response.ok)throw Error(this.dataset.errorLabel);html=(await response.json())[this.dataset.sectionId];}
    if(!html)throw Error(this.dataset.errorLabel);
    const doc=new DOMParser().parseFromString(html,'text/html'),next=doc.querySelector('mb-cart-drawer');if(!next)throw Error(this.dataset.errorLabel);
    const wasOpen=this.dialog.open,trigger=this.returnFocus;this.replacing=true;if(wasOpen)this.dialog.close();this.replaceWith(next);next.returnFocus=trigger;
    document.querySelectorAll('[data-cart-count]').forEach(el=>{if(el!==next)el.textContent=next.dataset.cartCount;});
    document.querySelectorAll('a.cart-link').forEach(el=>el.setAttribute('aria-label',`${next.querySelector('h2').textContent.trim()}`));
    if(wasOpen){document.body.classList.add('cart-open');next.dialog.showModal();next.querySelector('[data-close-cart]').focus();}return next;
  }
  async change(key,quantity,trigger){
    if(this.busy)return;this.busy=true;this.dialog.setAttribute('aria-busy','true');this.status(this.dataset.updatingLabel);this.querySelectorAll('button,input').forEach(el=>{if(!el.hasAttribute('data-close-cart'))el.disabled=true;});
    try{
      const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity,sections:[this.dataset.sectionId],sections_url:location.pathname})});
      const data=await response.json();if(!response.ok)throw Error(data.description||data.message||this.dataset.errorLabel);
      const action=trigger.hasAttribute('data-quantity-delta')?`[data-quantity-delta="${trigger.dataset.quantityDelta}"]`:'[data-line-quantity]';
      const next=await this.render(data.sections),row=[...next.querySelectorAll('[data-line-key]')].find(el=>el.dataset.lineKey===key);(row?.querySelector(action)||next.querySelector('[data-close-cart]')).focus();
    }catch(error){this.status(error instanceof TypeError?this.dataset.errorLabel:error.message||this.dataset.errorLabel);this.querySelectorAll('button,input').forEach(el=>el.disabled=false);this.dialog.removeAttribute('aria-busy');this.busy=false;}
  }
  disconnectedCallback(){document.removeEventListener('click',this.headerClick);}
}

class MultiBrandCollection extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.form=this.querySelector('form');this.drawer=this.querySelector('[data-filter-dialog]');this.mount=this.querySelector('[data-filter-mount]');this.anchor=document.createComment('Native filter form');this.form.before(this.anchor);
    this.drawer?.addEventListener('keydown',event=>containDialogFocus(event,this.drawer));
    const trigger=this.querySelector('[data-open-filters]');
    trigger?.addEventListener('click',()=>{this.mount.append(this.form);this.drawer.showModal();document.body.classList.add('filter-open');});
    this.querySelector('[data-close-filters]')?.addEventListener('click',()=>this.drawer.close());
    this.drawer?.addEventListener('click',event=>{if(event.target===this.drawer)this.drawer.close();});
    this.drawer?.addEventListener('close',()=>{document.body.classList.remove('filter-open');this.anchor.after(this.form);trigger.focus();});
    this.form.addEventListener('submit',()=>{this.form.setAttribute('aria-busy','true');this.querySelector('[data-filter-status]').textContent='Updating results…';});
    this.querySelector('[data-sort]')?.addEventListener('change', () => this.querySelector('form').requestSubmit());
    this.querySelectorAll('.filter-disclosure').forEach(detail => detail.addEventListener('toggle', () => {
      if (detail.open) this.querySelectorAll('.filter-disclosure').forEach(other => { if (other !== detail) other.open = false; });
    }));
  }
}

document.querySelectorAll('.search-page__form').forEach(form=>form.addEventListener('submit',()=>{form.setAttribute('aria-busy','true');document.querySelector('[data-search-status]').textContent='Searching…';}));

let sessionConsent = null;
class MultiBrandCookieConsent extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    let choice = sessionConsent;
    try { choice = localStorage.getItem('pomerk-cookie-choice-v1') || choice; } catch {}
    this.hidden = choice === 'all' || choice === 'essential';
    this.querySelectorAll('[data-consent]').forEach(button => button.addEventListener('click', () => {
      sessionConsent = button.dataset.consent;
      try { localStorage.setItem('pomerk-cookie-choice-v1', sessionConsent); } catch {}
      this.hidden = true;
    }));
  }
}

for (const [name, component] of Object.entries({ 'mb-navigation': MultiBrandNavigation, 'mb-slideshow': MultiBrandSlideshow, 'mb-product': MultiBrandProduct, 'mb-cart-drawer':MultiBrandCartDrawer, 'mb-collection-controls': MultiBrandCollection, 'mb-cookie-consent': MultiBrandCookieConsent })) {
  if (!customElements.get(name)) customElements.define(name, component);
}

// Content stays visible; only paint-time motion is added when a section enters view.
if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const reveal=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-entering');reveal.unobserve(entry.target);}}),{threshold:.08});
  document.querySelectorAll('.brand-directory .section-heading,.brand-feature__copy').forEach(el=>reveal.observe(el));
}

